/**
 * The practice path, in order. Branches (look around, invite) are not in this
 * list because they leave the path; Back and Next return you to it.
 */
export const TUTORIAL_PATH = [
  { id: 'welcome', label: 'Welcome' },
  { id: 'consent', label: 'Agree' },
  { id: 'sign', label: 'Sign' },
  { id: 'signed', label: 'Signed' },
  { id: 'detail', label: 'The record' },
  { id: 'verify', label: 'Verify' },
  { id: 'started', label: 'What next' },
] as const

export type TutorialPathId = (typeof TUTORIAL_PATH)[number]['id']
export type TutorialStep = TutorialPathId | 'look-around' | 'invite'

export function tutorialIndex(step: TutorialStep): number {
  return TUTORIAL_PATH.findIndex((s) => s.id === step)
}

export function tutorialOnPath(step: TutorialStep): boolean {
  return tutorialIndex(step) >= 0
}

/** Next step. Off the path, or past the last step, returns to welcome. */
export function tutorialNext(step: TutorialStep): TutorialStep {
  const at = tutorialIndex(step)
  if (at < 0 || at >= TUTORIAL_PATH.length - 1) return 'welcome'
  return TUTORIAL_PATH[at + 1].id
}

/** Previous step. Off the path returns to welcome. On the first step, stays. */
export function tutorialBack(step: TutorialStep): TutorialStep {
  const at = tutorialIndex(step)
  if (at < 0) return 'welcome'
  if (at === 0) return step
  return TUTORIAL_PATH[at - 1].id
}

export function tutorialNextLabel(step: TutorialStep): string {
  const at = tutorialIndex(step)
  if (at < 0) return 'Return to step 1'
  if (at >= TUTORIAL_PATH.length - 1) return 'Last step. Start again to replay'
  return `Next: ${TUTORIAL_PATH[at + 1].label}`
}
